import React, { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import Markdown from './components/Markdown';
import { Helmet } from 'react-helmet';

const Documents = ({ url }) => {
  const { onEnterChange } = useOutletContext();

  useEffect(() => {
    onEnterChange(false);

    scrollToTop();
  }, []);

  // 滚动到页面顶部的
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // 如果想要平滑滚动，可以使用 'smooth'
    });
  };
  // 根据一级路径判断是哪个模块
  let title = '爱瑟福信息科技(上海)有限公司-';
  if (url.includes('news')) {
    title += '新闻动态';
  } else if (url.includes('product')) {
    title += '产品与方案';
  }

  return (
    <div className="home-page-wrapper content6-wrapper common-section">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{title}</title>
      </Helmet>
      <Markdown url={url} />
    </div>
  );
};

export default Documents;
